/**
 * スクロールで発火する系のあれ。
 * scrollIn + アニメーションクラス名 を適用ブロックのクラスに追記
 * 発火後[active]クラス付与。
 */

jQuery(function ($) {
	function scrollChk(){
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();

			jQuery('.scrollIn').not('.active').each(function(){
					var pos = $(this).offset().top;

					if (scroll > pos - windowHeight){
							$(this).addClass("active");
					}
			});
	}
	$(window).scroll(function (){
			scrollChk();
	});
	$('body').on('touchmove', function() {
			scrollChk();
	});
});
